{
  "Country Road": {
    "group": "pixel-art",
    "type": "parallax",
    "props": {
      "name":"country-road",
      "widths":[384,160,384],
      "speeds":[1,0.4,0]
    },
    "colors": {
      "frame": "rgb(65,91,128)",
      "frame-item": "#fffffe",
      "baloon": "#fffffe",
      "baloon-item": "rgb(38,57,64)",
      "background": "rgb(139,176,231)",
      "background2": "rgb(98,133,173)",
      "highlight": "rgb(180,120,225)",
      "highlight2": "rgb(225,180,120)",
      "danger": "#fec7d7"
    }
  },
  "Mountain Dusk": {
    "group": "pixel-art",
    "type": "parallax",
    "props": {
      "name":"mountain-dusk",
      "widths":[544,544,544,272,272],
      "speeds":[1,0.5,0.1,0.05,0]
    },
    "colors": {
      "frame": "rgb(80,46,73)",
      "frame-item": "rgb(255,247,226)",
      "baloon": "rgb(255,247,226)",
      "baloon-item": "rgb(47,33,56)",
      "background": "rgb(171,106,140)",
      "background2": "rgb(101,54,86)",
      "highlight": "#2cb67d",
      "highlight2": "#7f5af0",
      "danger": "#fec7d7"
    }
  },
  "Into the Forest": {
    "group": "pixel-art",
    "type": "parallax",
    "props": {
      "name":"into-the-forest",
      "widths":[272,272,272,272],
      "speeds":[1,0.4,0.2,0.1]
    },
    "colors": {
      "frame": "rgb(90,110,60)",
      "frame-item": "rgb(255,246,200)",
      "baloon": "rgb(255,246,200)",
      "baloon-item": "rgb(40,40,48)",
      "background": "rgb(176,112,48)",
      "background2": "rgb(68,48,37)",
      "highlight": "#2cb67d",
      "highlight2": "#7f5af0",
      "danger": "#fec7d7"
    }
  },
  "Underwater Fantasy": {
    "group": "pixel-art",
    "type": "parallax",
    "props": {
      "name":"underwater-fantasy",
      "widths":[512,256,256],
      "speeds":[1,0.4,0.1]
    },
    "colors": {
      "frame": "rgb(11,29,66)",
      "frame-item": "rgb(118,185,216)",
      "baloon": "rgb(118,185,216)",
      "baloon-item": "rgb(11,29,66)",
      "background": "rgb(62,121,221)",
      "background2": "rgb(35,79,161)",
      "highlight": "rgb(158,60,212)",
      "highlight2": "rgb(158,212,60)",
      "danger": "#fec7d7"
    }
  },
  "Urban Landscape": {
    "group": "pixel-art",
    "type": "parallax",
    "props": {
      "name":"urban-landscape",
      "widths":[192,112],
      "speeds":[0.5,0.1]
    },
    "colors": {
      "frame": "rgb(102,152,160)",
      "frame-item": "#fffffe",
      "baloon": "rgb(203,225,233)",
      "baloon-item": "#094067",
      "background": "rgb(182,211,225)",
      "background2": "rgb(203,225,233)",
      "highlight": "#fbdd44",
      "highlight2": "#60ff52",
      "danger": "#fec7d7"
    }
  },
  "Industrial Night": {
    "group": "pixel-art",
    "type": "parallax",
    "props": {
      "name":"industrial-night",
      "widths":[272,272,272,272],
      "speeds":[1,0.5,0.2,0]
    },
    "colors": {
      "frame": "rgb(45,128,128)",
      "frame-item": "rgb(199,246,194)",
      "baloon": "rgb(199,246,194)",
      "baloon-item": "rgb(25,40,31)",
      "background": "rgb(25,40,31)",
      "background2": "rgb(44,109,72)",
      "highlight": "#e16162",
      "highlight2": "#f9bc60",
      "danger": "#fec7d7"
    }
  },
  "Cyberpunk Street": {
    "group": "pixel-art",
    "type": "parallax",
    "props": {
      "name":"cyberpunk-street",
      "widths":[352,256,256],
      "speeds":[1,0.5,0.1]
    },
    "colors": {
      "frame": "rgb(248,130,62)",
      "frame-item": "rgb(0,53,78)",
      "baloon": "rgb(0,74,88)",
      "baloon-item": "rgb(242,219,192)",
      "background": "rgb(38,4,12)",
      "background2": "rgb(188,67,13)",
      "highlight": "rgb(180,57,115)",
      "highlight2": "rgb(226,42,58)",
      "danger": "rgb(226,42,58)"
    }
  },
  "Pale Purple": {
    "group": "simple",
    "type": "checker",
    "colors": {
      "frame": "#67568c",
      "frame-item": "#fffffe",
      "baloon": "#fffffe",
      "baloon-item": "#1b1425",
      "background": "#e2daeb",
      "background2": "#f4effc",
      "highlight": "#ff6e6c",
      "highlight2": "#fbdd44",
      "danger": "#fec7d7"
    }
  },
  "Pale Brown": {
    "group": "simple",
    "type": "checker",
    "colors": {
      "frame": "#8c7851",
      "frame-item": "#fffffe",
      "baloon": "#f9f4ef",
      "baloon-item": "#716040",
      "background": "#eaddcf",
      "background2": "#f9f4ef",
      "highlight": "#f25042",
      "highlight2": "#50f242",
      "danger": "#fec7d7"
    }
  },
  "Serene Sky": {
    "group": "simple",
    "type": "character",
    "props": {
      "character": "☁"
    },
    "colors": {
      "frame": "#90b4ce",
      "frame-item": "#fffffe",
      "baloon": "#fffffe",
      "baloon-item": "#094067",
      "background": "#fffffe",
      "background2": "#d8eefe",
      "highlight": "#fbdd44",
      "highlight2": "#60ff52",
      "danger": "#fec7d7"
    }
  },
  "Summer Vacation": {
    "group": "simple",
    "type": "character",
    "props": {
      "character": "☻"
    },
    "colors": {
      "frame": "#f8d401",
      "frame-item": "#272343",
      "baloon": "#fffffe",
      "baloon-item": "#272343",
      "background": "#fffffe",
      "background2": "#c3d6f5",
      "highlight": "#9ac8c8",
      "highlight2": "#c89ac8",
      "danger": "#eea7b7"
    }
  },
  "Magical Girl": {
    "group": "simple",
    "type": "character",
    "props": {
      "character": "♠"
    },
    "colors": {
      "frame": "#a786df",
      "frame-item": "#fffffe",
      "baloon": "#f9f8fc",
      "baloon-item": "#0e172c",
      "background": "#fec7d7",
      "background2": "#f9f8fc",
      "highlight": "#fea7b7",
      "highlight2": "#b9b4e7",
      "danger": "#fec7d7"
    }
  },
  "Spring Rain": {
    "group": "simple",
    "type": "character",
    "props": {
      "character": "☂"
    },
    "colors": {
      "frame": "#6246ca",
      "frame-item": "#fffffe",
      "baloon": "#fffffe",
      "baloon-item": "#2b2c34",
      "background": "#fffffe",
      "background2": "#d1d1e9",
      "highlight": "#ff7878",
      "highlight2": "#9191e9",
      "danger": "#fec7d7"
    }
  },
  "Weed Green": {
    "group": "simple",
    "type": "character",
    "props": {
      "character": "☘"
    },
    "colors": {
      "frame": "#004643",
      "frame-item": "#e8e4e6",
      "baloon": "#e8e4e6",
      "baloon-item": "#001e1d",
      "background": "#e8e4e6",
      "background2": "#abd1c6",
      "highlight": "#e16162",
      "highlight2": "#f9bc60",
      "danger": "#fec7d7"
    }
  },
  "Heart Pink": {
    "group": "simple",
    "type": "character",
    "props": {
      "character": "♥"
    },
    "colors": {
      "frame": "#ff8ba7",
      "frame-item": "#fffffe",
      "baloon": "#fffffe",
      "baloon-item": "#594a4e",
      "background": "#faeee7",
      "background2": "#ffc6c7",
      "highlight": "#4cd69d",
      "highlight2": "#9f7aff",
      "danger": "#fec7d7"
    }
  },
  "Dance Floor": {
    "group": "simple",
    "type": "checker",
    "colors": {
      "frame": "#994ff3",
      "frame-item": "#fffffe",
      "baloon": "#f2eef5",
      "baloon-item": "#181818",
      "background": "#4fc4cf",
      "background2": "#fbdd74",
      "highlight": "#f25042",
      "highlight2": "#40e232",
      "danger": "#fec7d7"
    }
  },
  "Azuki Beans": {
    "group": "simple",
    "type": "checker",
    "colors": {
      "frame": "#232946",
      "frame-item": "#fffffe",
      "baloon": "#b8c1ec",
      "baloon-item": "#121629",
      "background": "#d4939d",
      "background2": "#eebbc3",
      "highlight": "#fbdd44",
      "highlight2": "#60ff52",
      "danger": "#fec7d7"
    }
  },
  "Just Gray": {
    "group": "simple",
    "type": "checker",
    "colors": {
      "frame": "#333",
      "frame-item": "#eee",
      "baloon": "#eee",
      "baloon-item": "#333",
      "background": "#777",
      "background2": "#999",
      "highlight": "#ff6e6c",
      "highlight2": "#fbdd44",
      "danger": "#fec7d7"
    }
  },
  "Chocolate": {
    "group": "simple",
    "type": "checker",
    "colors": {
      "frame": "#ffc0ad",
      "frame-item": "#271c19",
      "baloon": "#fff3ec",
      "baloon-item": "#140d0b",
      "background": "#271c19",
      "background2": "#55423d",
      "highlight": "#e78fb3",
      "highlight2": "#9656a1",
      "danger": "#eea7b7"
    }
  },
  "Fire in Dark": {
    "group": "simple",
    "type": "checker",
    "colors": {
      "frame": "#f25f4c",
      "frame-item": "#fffffe",
      "baloon": "#fffffe",
      "baloon-item": "#0f0e17",
      "background": "#0f0e17",
      "background2": "#2e2f3e",
      "highlight": "#7f5af0",
      "highlight2": "#2cb67d",
      "danger": "#fec7d7"
    }
  },
  "Deep Dark": {
    "group": "simple",
    "type": "checker",
    "colors": {
      "frame": "#72757e",
      "frame-item": "#fffffe",
      "baloon": "#fffffe",
      "baloon-item": "16161a",
      "background": "#16161a",
      "background2": "#242629",
      "highlight": "#2cb67d",
      "highlight2": "#7f5af0",
      "danger": "#fec7d7"
    }
  }
}